module.exports = __webpack_public_path__ + "img/b.1569007c.jpg";